import Badge from '@mui/material/Badge'
import { reExportedColors } from './index'

const CountBadge = ({
  children,
  count,
  color,
  className,
  sx,
  overlap = 'rectangular'
}) => (
  <Badge
    badgeContent={count || 0}
    className={className}
    overlap={overlap}
    sx={[
      (theme) => ({
        '& .MuiBadge-badge': {
          background: color || reExportedColors.ERROR_RED,
          color: theme.palette.secondary.accent,
          display: count === 0 ? 'none' : undefined,
          right: '-8px',
          transformOrigin: 'center'
        }
      }),
      ...(sx ? (Array.isArray(sx) ? sx : [sx]) : [])
    ]}
  >
    {children}
  </Badge>
)

export default CountBadge
